/**
 * @description 使用者身份類型 (enum)
 */
export enum UserIdentityTypesEnum {
  /** 僅為網服會員 */
  NS = 'NS',
  /** 僅為網投會員 */
  OIS = 'OIS',
  /** 網服、網投兩者都是會員 */
  BH = 'BH',
  /** 非會員 */
  NA = 'NA'
}
